(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue'), require('rxjs'), require('rxjs/operators')) :
  typeof define === 'function' && define.amd ? define(['exports', 'vue', 'rxjs', 'rxjs/operators'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.VueNextRx = {}, global.Vue, global.rxjs, global.rxjs.operators));
})(this, (function (exports, vue, rxjs, operators) { 'use strict';

  function ref(value) {
    var $ref = vue.ref(value);
    var subject = new rxjs.Subject();
    $ref.next = subject.next.bind(subject);
    $ref.pipe = subject.pipe.bind(subject);
    $ref.subscribe = subject.subscribe.bind(subject);
    vue.watch($ref, function (newValue) {
      subject.next(newValue);
    });
    vue.onBeforeUnmount(function () { return subject.unsubscribe(); });
    return $ref;
  }

  function watch(ref, fn) {
    if ( fn === void 0 ) fn = null;

    var subject = new rxjs.Subject();
    var $watch = vue.watch(ref, function (val) {
      subject.next(val);
      if (fn) { fn(val); }
    });
    $watch.next = subject.next.bind(subject);
    $watch.pipe = subject.pipe.bind(subject);
    $watch.subscribe = subject.subscribe.bind(subject);
    $watch.unsubscribe = subject.unsubscribe.bind(subject);
    vue.onBeforeUnmount(function () { return subject.unsubscribe(); });

    return $watch;
  }

  var warn = function (error) {
    console.log("vue-next-rx : " + error);
  };

  function isObserver(subject) {
    return subject && typeof subject.next === "function";
  }

  function getKey(binding) {
    return [binding.arg].concat(Object.keys(binding.modifiers)).join(":");
  }

  function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) { return (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16); }
    );
  }

  /**
   * @name Vue.prototype.$createObservableMethod
   * @description Creates an observable from a given function name.
   * @param {String} methodName Function name
   * @param {Boolean} [passContext] Append the call context at the end of emit data?
   * @return {Observable} Hot stream
   */
  function createObservableMethod(methodName, passContext) {
    var vm = this;
    if (vm[methodName] !== undefined) {
      warn(
        "Potential bug: " +
          "Method " + methodName + " already defined on vm and has been overwritten by $createObservableMethod." +
          String(vm[methodName]));
    }

    var creator = function (observer) {
      vm[methodName] = function () {
        var args = Array.from(arguments);
        if (passContext) {
          args.push(this);
          observer.next(args);
        } else {
          if (args.length <= 1) {
            observer.next(args[0]);
          } else {
            observer.next(args);
          }
        }
      };
      return function () {
        delete vm[methodName];
      };
    };

    // Must be a hot stream otherwise function context may overwrite over and over again
    return new rxjs.Observable(creator).pipe(operators.share());
  }

  function fromDomEvent(selector, event) {
    if (typeof window === "undefined") {
      // TODO(benlesh): I'm not sure if this is really what you want here,
      // but it's equivalent to what you were doing. You might want EMPTY
      return rxjs.NEVER;
    }

    var vm = this;
    var doc = document.documentElement;
    var obs$ = new rxjs.Observable(function (observer) {
      function listener(e) {
        if (!vm.$el) { return; }
        if (selector === null && vm.$el === e.target) { return observer.next(e); }
        var els = vm.$el.querySelectorAll(selector);
        var el = e.target;
        for (var i = 0, len = els.length; i < len; i++) {
          if (els[i] === el) { return observer.next(e); }
        }
      }
      doc.addEventListener(event, listener);
      // Returns function which disconnects the $watch expression
      return new rxjs.Subscription(function () {
        doc.removeEventListener(event, listener);
      });
    });

    return obs$;
  }

  function subscribeTo(observable) {
    var subscribeArgs = [], len = arguments.length - 1;
    while ( len-- > 0 ) subscribeArgs[ len ] = arguments[ len + 1 ];

    var subscription = observable.subscribe.apply(observable, subscribeArgs);
    (this._subscription || (this._subscription = new rxjs.Subscription())).add(
      subscription
    );
    return subscription;
  }

  function watchAsObservable(expOrFn, options) {
    var vm = this;
    var obs$ = new rxjs.Observable(function (observer) {
      var watch = function () {
        vm.$watch(
          expOrFn,
          function (newValue, oldValue) {
            observer.next({ oldValue: oldValue, newValue: newValue });
          },
          options
        );
      };

      // if $watchAsObservable is called inside the subscriptions function,
      // because data hasn't been observed yet, the watcher will not work.
      // in that case, wait until created hook to watch.
      setTimeout(function () {
        watch();
      }, 0);

      // Returns function which disconnects the $watch expression
      return new rxjs.Subscription(function () {
      });
    });

    return obs$;
  }

  var streamDirective = {
    // Example ./example/counter_dir.html
    mounted: function mounted(el, binding, vnode) {
      var handle = binding.value;
      var event = binding.arg;
      var streamName = binding.expression;
      var modifiers = binding.modifiers;

      if (isObserver(handle)) {
        handle = { subject: handle };
      } else if (!handle || !isObserver(handle.subject)) {
        warn(
          'Invalid Subject found in directive with key "' +
            streamName +
            '".' +
            streamName +
            " should be an instance of Subject or have the " +
            "type { subject: Subject, data: any }.",
          vnode.context
        );
        return;
      }

      var modifiersFuncs = {
        stop: function (e) { return e.stopPropagation(); },
        prevent: function (e) { return e.preventDefault(); },
      };

      var modifiersExists = Object.keys(modifiersFuncs).filter(
        function (key) { return modifiers[key]; }
      );

      var subject = handle.subject;
      var next = (subject.next || subject.onNext).bind(subject);

      if (!modifiers.native && vnode.componentInstance) {
        handle.subscription = vnode.componentInstance
          .$eventToObservable(event)
          .subscribe(function (e) {
            modifiersExists.forEach(function (mod) { return modifiersFuncs[mod](e); });
            next({
              event: e,
              data: handle.data,
            });
          });
      } else {
        var fromEventArgs = handle.options
          ? [el, event, handle.options]
          : [el, event];
        handle.subscription = rxjs.fromEvent.apply(void 0, fromEventArgs).subscribe(function (e) {
          modifiersExists.forEach(function (mod) { return modifiersFuncs[mod](e); });
          next({
            event: e,
            data: handle.data,
          });
        });
      }

      // store handle on element with a unique key for identifying
      // multiple v-stream directives on the same node
      (el._rxHandles || (el._rxHandles = {}))[getKey(binding)] = handle;
    },

    updated: function updated(el, binding) {
      var handle = binding.value;
      var _handle = el._rxHandles && el._rxHandles[getKey(binding)];
      if (_handle && handle && isObserver(handle.subject)) {
        Object.assign(_handle, handle);
      }
    },

    unmounted: function unmounted(el, binding) {
      var key = getKey(binding);
      var handle = el._rxHandles && el._rxHandles[key];
      if (handle) {
        if (handle.subscription) {
          handle.subscription.unsubscribe();
        }
        el._rxHandles[key] = null;
      }
    },
  };

  var rxMixin = {
    created: function created() {
      var vm = this;
      var domStreams = vm.$options.domStreams;

      if (domStreams) {
        domStreams.forEach(function (key) {
          vm[key] = new rxjs.Subject();
        });
      }

      var observableMethods = vm.$options.observableMethods;
      if (observableMethods) {
        if (Array.isArray(observableMethods)) {
          observableMethods.forEach(function (methodName) {
            vm[methodName + "$"] = vm.$createObservableMethod(methodName);
          });
        } else {
          Object.keys(observableMethods).forEach(function (methodName) {
            vm[observableMethods[methodName]] =
              vm.$createObservableMethod(methodName);
          });
        }
      }

      var obs = vm.$options.subscriptions;
      if (typeof obs === "function") {
        obs = obs.call(vm);
      }
      if (obs) {
        vm.$observables = {};
        vm._subscription = new rxjs.Subscription();
        Object.keys(obs).forEach(function (key) {
          vm[key] = undefined;
          var ob = (vm.$observables[key] = obs[key]);
          if (!rxjs.isObservable(ob)) {
            warn(
              'Invalid Observable found in subscriptions option with key "' +
                key +
                '".');
            return;
          }
          vm._subscription.add(
            obs[key].subscribe(
              function (value) {
                vm[key] = value;
                try {
                  vm.$forceUpdate();
                } catch (e) {
                  var currentInst = vue.getCurrentInstance();
                  var newKey = uuidv4();
                  // try to force new key if force update fails (usually fails when it is created on created hook)
                  if (currentInst && currentInst.vnode) {
                    currentInst.vnode.key = newKey;
                  } else if (vm.$ && vm.$.subTree) {
                    vm.$.subTree.key = newKey;
                  } else if (currentInst && currentInst.subTree) {
                    currentInst.subTree.key = newKey;
                  }
                }
              },
              function (error) {
                throw error;
              }
            )
          );
        });
      }
    },

    beforeUnmount: function beforeUnmount() {
      if (this._subscription) {
        this._subscription.unsubscribe();
      }
    },
  };

  //TODO: Work also with vue
  var index = {
    install: install,
  };
  var _Vue;

  function install(Vue) {
    Vue.mixin(rxMixin);
    Vue.directive("stream", streamDirective);
    Vue.config.globalProperties.$watchAsObservable = watchAsObservable;
    Vue.config.globalProperties.$fromDOMEvent = fromDomEvent;
    Vue.config.globalProperties.$subscribeTo = subscribeTo;
    Vue.config.globalProperties.$createObservableMethod = createObservableMethod;
    Vue.config.optionMergeStrategies.subscriptions = function (toVal, fromVal) {
      return fromVal || toVal;
    };
    this._Vue = Vue;
  }

  exports._Vue = _Vue;
  exports["default"] = index;
  exports.install = install;
  exports.ref = ref;
  exports.watch = watch;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
